import $ from 'jquery';
import lottie from 'lottie-web';
import { checkWebpSupport } from '../utils/webp';
export default class LottieAnimationLoader {
    static dataRequests = new Map();
    assetUrlsRequest = Promise.resolve({});
    source = '';
    static init(source, assetSources) {
        const loader = new LottieAnimationLoader();
        loader.assetUrlsRequest = this.resolveAssetUrls(assetSources);
        loader.source = source;
        return loader;
    }
    static parseAssetSources(value) {
        if (!value) {
            return null;
        }
        try {
            const parsed = JSON.parse(value);
            if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') {
                return null;
            }
            const entries = Object.entries(parsed);
            if (entries.some(([filename, source]) => {
                if (!filename) {
                    return true;
                }
                if (typeof source === 'string') {
                    return !source;
                }
                if (!source || Array.isArray(source) || typeof source !== 'object') {
                    return true;
                }
                const assetSource = source;
                return (typeof assetSource.default !== 'string' ||
                    !assetSource.default ||
                    (assetSource.webp !== undefined && (typeof assetSource.webp !== 'string' || !assetSource.webp)));
            })) {
                return null;
            }
            return Object.fromEntries(entries);
        }
        catch (_error) {
            return null;
        }
    }
    load(container) {
        return Promise.all([LottieAnimationLoader.getAnimationData(this.source), this.assetUrlsRequest]).then(([data, assetUrls]) => {
            const player = lottie.loadAnimation({
                container,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                animationData: LottieAnimationLoader.cloneAnimationData(data, assetUrls),
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid meet',
                },
            });
            return this.waitUntilLoaded(player).then(() => player);
        });
    }
    static async resolveAssetUrls(assetSources) {
        const isWebpSupported = await checkWebpSupport();
        return Object.fromEntries(Object.entries(assetSources).map(([filename, source]) => [
            filename,
            typeof source === 'string' ? source : (isWebpSupported && source.webp) || source.default,
        ]));
    }
    static getAnimationData(source) {
        const existingRequest = this.dataRequests.get(source);
        if (existingRequest) {
            return existingRequest;
        }
        const request = new Promise((resolve, reject) => {
            $.getJSON(source)
                .done(data => resolve(data))
                .fail((_jqXHR, textStatus, errorThrown) => reject(errorThrown || new Error(textStatus)));
        });
        this.dataRequests.set(source, request);
        void request.catch(() => this.dataRequests.delete(source));
        return request;
    }
    static cloneAnimationData(data, assetUrls) {
        const clonedData = JSON.parse(JSON.stringify(data));
        clonedData.assets?.forEach(asset => {
            const imageUrl = asset.p ? assetUrls[asset.p] : undefined;
            if (imageUrl) {
                asset.e = 1;
                asset.p = imageUrl;
                asset.u = '';
            }
        });
        return clonedData;
    }
    waitUntilLoaded(player) {
        if (player.isLoaded) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            const removeLoadedListener = player.addEventListener('DOMLoaded', () => {
                removeErrorListener();
                resolve();
            });
            const removeErrorListener = player.addEventListener('data_failed', () => {
                removeLoadedListener();
                player.destroy();
                reject(new Error('Unable to load Lottie animation'));
            });
        });
    }
}
